import CloseIcon from "@mui/icons-material/Close";
import {
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { format, isValid, parseISO } from "date-fns";
import { IInstallmentHistoryEntry } from "../../../../shared/services/api/sinister/SinisterAgreementService";
import { formatDateFnsRemoveTimezone } from "../../../../shared/utils/format-date";
import { getPaymentMethodLabel } from "../../../creditRecovery/constants/paymentMethodOptions";

const formatDateTimeSafe = (dateString?: string): string => {
	if (!dateString) return "-";
	const parsed = parseISO(dateString);
	return isValid(parsed) ? format(parsed, "dd/MM/yyyy HH:mm") : "-";
};

interface Props {
	open: boolean;
	installmentNumber: number;
	history: IInstallmentHistoryEntry[];
	onClose: () => void;
}

const EVENT_LABEL: Record<IInstallmentHistoryEntry["type"], string> = {
	reissue: "Nova via gerada",
	manual_settlement: "Baixa manual",
	cancellation: "Parcela cancelada",
};

export const ModalInstallmentHistory = ({ open, installmentNumber, history, onClose }: Props) => {
	const entries = history.filter((entry) => entry.installmentNumber === installmentNumber).sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
			<DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<Typography variant="h6" color="primary" sx={{ fontWeight: 400 }}>
					Histórico da Parcela {installmentNumber}
				</Typography>
				<IconButton onClick={onClose} size="small">
					<CloseIcon fontSize="small" />
				</IconButton>
			</DialogTitle>

			<DialogContent dividers>
				{entries.length === 0 ? (
					<Typography variant="body2" color="text.secondary">
						Nenhuma movimentação registrada para essa parcela.
					</Typography>
				) : (
					<TableContainer>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell>Evento</TableCell>
									<TableCell align="center">Vencimento (de → para)</TableCell>
									<TableCell align="center">Forma de pagamento</TableCell>
									<TableCell align="center">Data</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{entries.map((entry) => (
									<TableRow key={entry.id}>
										<TableCell>
											<Typography variant="body2">{EVENT_LABEL[entry.type]}</Typography>
											{entry.note && (
												<Typography variant="caption" color="text.secondary">
													{entry.note}
												</Typography>
											)}
										</TableCell>
										<TableCell align="center">
											{formatDateFnsRemoveTimezone(entry.previousDueDate) || "-"} → {formatDateFnsRemoveTimezone(entry.newDueDate) || "-"}
										</TableCell>
										<TableCell align="center">{entry.paymentMethod ? getPaymentMethodLabel(entry.paymentMethod) : "—"}</TableCell>
										<TableCell align="center">{formatDateTimeSafe(entry.createdAt)}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				)}
			</DialogContent>
		</Dialog>
	);
};
